import {CartTimerIcon, HotIcon, MegaphoneIcon, PercentIcon} from "@pg-design/icons-module";

import {PromotionType} from "../helpers/PromotionType";

interface IGetPromotionStyleOutput {
    icon: React.JSX.Element | null;
    color: string;
}

export function getPromotionStyle(type: PromotionType): IGetPromotionStyleOutput {
    switch (type) {
        case PromotionType.OPEN_DAYS:
            return {
                icon: <MegaphoneIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-background-200)" />,
                color: "var(--colors-background-200)"
            };
        case PromotionType.DISCOUNT:
            return {
                icon: <PercentIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-info)" />,
                color: "var(--colors-info)"
            };
        case PromotionType.LAST_MINUTE:
            return {
                icon: <CartTimerIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-warning)" />,
                color: "var(--colors-warning)"
            };
        case PromotionType.PRESALE:
            return {
                icon: <MegaphoneIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-success)" />,
                color: "var(--colors-success)"
            };
        case PromotionType.EXHIBITION: //TODO: Not used anymore, remove implementation and usages in the app
            return {icon: null, color: "var(--colors-gray-200)"};
        default:
            //  OFFER
            return {
                icon: <HotIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-highlight)" />,
                color: "var(--colors-highlight)"
            };
    }
}
import {CartTimerIcon, HotIcon, MegaphoneIcon, PercentIcon} from "@pg-design/icons-module";

import {PromotionType} from "../helpers/PromotionType";

interface IGetPromotionStyleOutput {
    icon: React.JSX.Element | null;
    color: string;
}

export function getPromotionStyle(type: PromotionType): IGetPromotionStyleOutput {
    switch (type) {
        case PromotionType.OPEN_DAYS:
            return {
                icon: <MegaphoneIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-background-200)" />,
                color: "var(--colors-background-200)"
            };
        case PromotionType.DISCOUNT:
            return {
                icon: <PercentIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-info)" />,
                color: "var(--colors-info)"
            };
        case PromotionType.LAST_MINUTE:
            return {
                icon: <CartTimerIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-warning)" />,
                color: "var(--colors-warning)"
            };
        case PromotionType.PRESALE:
            return {
                icon: <MegaphoneIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-success)" />,
                color: "var(--colors-success)"
            };
        case PromotionType.EXHIBITION: //TODO: Not used anymore, remove implementation and usages in the app
            return {icon: null, color: "var(--colors-gray-200)"};
        default:
            //  OFFER
            return {
                icon: <HotIcon size="2.56" wrapperSize="5" wrapperColor="var(--colors-highlight)" />,
                color: "var(--colors-highlight)"
            };
    }
}
